
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hera",
      function () {
        return require("private-next-pages/hera/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hera"])
      });
    }
  